import { render, staticRenderFns } from "./accountingKindProductGiven.vue?vue&type=template&id=0a4bd1b4&"
import script from "./accountingKindProductGiven.vue?vue&type=script&lang=js&"
export * from "./accountingKindProductGiven.vue?vue&type=script&lang=js&"
import style0 from "./accountingKindProductGiven.vue?vue&type=style&index=0&id=0a4bd1b4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports